import Api from './api'

const environment = process.env.NODE_ENV

export const api = Api(environment)
